<template>
  <div>
    <div class="d-flex justify-content-end mb-3">
      <CButton color="primary" @click="fetchIssues(true)" :disabled="loading">
        <CIcon name="cil-reload" class="align-bottom mr-2" />
        <strong>Refresh Issues</strong>
      </CButton>
    </div>

    <CSpinner v-if="loading" />
    
    <div v-else>
      <CRow>
        <CCol col="12" lg="6">
          <h6 class="mb-2">Same hero used by multiple restaurants (grouped by zip)</h6>
          <ul class="mb-4 hero-issue-list">
            <li v-if="!issues.duplicateHeroInZip?.length" class="text-muted">No issues found.</li>
            <li v-for="(group, idx) in issues.duplicateHeroInZip" :key="`dups-${group.zip}-${group.image_id || idx}`" class="mb-3">
              <div class="d-flex align-items-center mb-2">
                <CImg
                  v-if="group.image_url"
                  :src="group.image_url"
                  class="hero-thumb mr-3"
                  alt="Hero preview"
                />
                <div>
                  <strong>Zip {{ group.zip }}</strong> — {{ group.restaurants.length }} restaurants
                </div>
              </div>
              <ul>
                <li v-for="r in group.restaurants" :key="`r-${r.id}`">
                  <router-link :to="{ name: 'View Restaurant', params: { id: r.id } }" target="_blank">
                    #{{ r.id }} — {{ r.name }}
                  </router-link>
                </li>
              </ul>
            </li>
          </ul>
        </CCol>
        <CCol col="12" lg="6">
          <h6 class="mb-2">Restaurants without hero image (grouped by zip)</h6>
          <ul class="hero-issue-list">
            <li v-if="!issues.noHeroInZip?.length" class="text-muted">No issues found.</li>
            <li v-for="(group, idx) in issues.noHeroInZip" :key="`nohero-${group.zip}-${idx}`">
              <strong>Zip {{ group.zip }}</strong> — {{ group.restaurants.length }} restaurants
              <ul>
                <li v-for="r in group.restaurants" :key="`r-${r.id}`">
                  <router-link :to="{ name: 'View Restaurant', params: { id: r.id } }" target="_blank">
                    #{{ r.id }} — {{ r.name }}
                  </router-link>
                </li>
              </ul>
            </li>
          </ul>
        </CCol>
      </CRow>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RestaurantsHeroImageIssues',
  props: {
    active: { type: Boolean, default: false }
  },
  data() {
    return {
      loading: false,
      issues: {
        duplicateHeroInZip: [],
        noHeroInZip: []
      }
    }
  },
  watch: {
    active(val) {
      if (val) { this.fetchIssues(); }
    }
  },
  mounted() {
    if (this.active) {
      this.fetchIssues();
    }
  },
  methods: {
    async fetchIssues(force = false) {
      this.loading = true;
      try {
        const { data } = await this.$axios.get(this.$backend.ISSUE.GET, {
          params: {
            issue: 'restaurants-hero-image-issues',
            force
          }
        });
        this.issues = data.data || {};
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.hero-thumb {
  max-width: 120px;
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.hero-issue-list li {
  line-height: 1.4;
}
</style>


